/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMoneyInIBANDetailsInput
 */
export interface GetMoneyInIBANDetailsInput {
    /**
     * UTC Unix Timestamp
     * @type {string}
     * @memberof GetMoneyInIBANDetailsInput
     */
    updateDate: string;
    /**
     * End Date tUTC Unix Timestamp
     * @type {string}
     * @memberof GetMoneyInIBANDetailsInput
     */
    updateEndDate: string;
}

/**
 * Check if a given object implements the GetMoneyInIBANDetailsInput interface.
 */
export function instanceOfGetMoneyInIBANDetailsInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updateDate" in value;
    isInstance = isInstance && "updateEndDate" in value;

    return isInstance;
}

export function GetMoneyInIBANDetailsInputFromJSON(json: any): GetMoneyInIBANDetailsInput {
    return GetMoneyInIBANDetailsInputFromJSONTyped(json, false);
}

export function GetMoneyInIBANDetailsInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyInIBANDetailsInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updateDate': json['updateDate'],
        'updateEndDate': json['updateEndDate'],
    };
}

export function GetMoneyInIBANDetailsInputToJSON(value?: GetMoneyInIBANDetailsInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updateDate': value.updateDate,
        'updateEndDate': value.updateEndDate,
    };
}

